module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.name === 'Announcement') ? _c('section', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('Announcement')], 1)], 1) : (_vm.$root.hasUser) ? _c('div', {
    staticClass: "wrapper"
  }, [(_vm.$root.device.isMobile) ? _c('NaviMobile') : _c('NaviBar'), _vm._v(" "), _c('Slider'), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('ContentWrapMobile', {
    staticClass: "sidebar-toggle"
  }) : _c('ContentWrap'), _vm._v(" "), _c('Modal')], 1) : (_vm.$route.name !== 'Home') ? _c('section', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('Login')], 1)], 1) : _c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('Home')], 1), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right",
      "closeOnClick": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63e7e813!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 718
// module chunks = 0